import { Description } from "@material-ui/icons";
import { Col, Descriptions, Row } from "antd";

export default function DetalhePlanoContaContabil({ dadosModal }) {

    const dados = dadosModal || {};

    return (
        <div>
            <Row>
                <Col>
                    <Descriptions>
                        <Descriptions.Item label="ID">
                            <b>{(dados.pcc_id)}</b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Descrição da Conta">
                            <b>{(dados.pcc_descricao)}</b>
                        </Descriptions.Item>
                    </Descriptions>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Descriptions>
                        <Descriptions.item label="Código estruturado">
                            <b>{(dados.pcc_codigoestruturado)}</b>
                        </Descriptions.item>
                        <Descriptions.Item label="Código Reduzido">
                            <b>{(dados.pcc_codigoreduzido)}</b>
                        </Descriptions.Item>
                        <Descriptions.Item label="grau">
                            <b>{(dados.pcc_grau)}</b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Analitico X Sintético">
                            <b>{(dados.pcc_analiticosintetico)}</b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Natureza Contábil">
                            <b>{(dados.pcc_natureza)}</b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Contas Pai">
                            {dadosModal?.planocontacontabilpai?.map((contaPai, index) => (
                                <div key={index}>{contaPai.pcc_descricao}</div>
                            ))}
                        </Descriptions.Item>
                    </Descriptions>
                </Col>
            </Row>

        </div>

    )
}